import React, { useEffect, useState } from "react";
import { confirmable } from "react-confirm";
import { Switch, Row, message, TreeSelect, Radio, Input, Spin } from "antd";
import Modal from "antd/lib/modal/Modal";
import "./ScheduleModal.css";
import ScheduleDlgContent from "./ScheduleDlgContent";
import DivisionTable from "./DivisionTable";
import { apiSetupSchedule } from "services/divisionService";

function ScheduleModal(props) {
  const {
    show,
    proceed,
    title,
    divisionList,
    token,
    club_id,
    registration_id,
  } = props;

  const [titleLabel, setTitleLabel] = useState("");
  const [selDivision, setSelDivision] = useState();
  const [oneSchedule, setOneSchedule] = useState({});
  const [errorField, setErrorField] = useState([]);
  const [isBusy, setIsBusy] = useState(false);
  const [busyMessage, setBusyMessage] = useState("");
  const [progressInterval, setProgressInterval] = useState(null);

  useEffect(() => {
    if (title != undefined) {
      setTitleLabel(title);
    }
  }, []);

  useEffect(() => {
    return () => {
      // Cleanup interval on component unmount
      if (progressInterval) {
        clearInterval(progressInterval);
      }
    };
  }, [progressInterval]);

  const onCreate = () => {
    // Go back to division table instead of closing modal
    setSelDivision(undefined);
    setTitleLabel("Auto Schedule");
  };

  const stopProgress = () => {
    if (progressInterval) {
      clearInterval(progressInterval);
    }
    setProgressInterval(null);
    setBusyMessage("");
    setIsBusy(false);
  };

  const editSetup = (info) => {
    console.log(`[DEBUG] editSetup called for setup_id: ${info.setup_id}`, info);
    const messages = [
      "Initializing schedule creation...",
      "Analyzing team matchups...",
      "Generating game slots...",
      "Assigning locations and times...",
      "Finalizing schedule... this may take a moment.",
    ];
    let messageIndex = 0;

    // Function to update message
    const updateMessage = () => {
      if (messageIndex < messages.length) {
        const nextMessage = messages[messageIndex];
        console.log(`[DEBUG] Progress Step: "${nextMessage}"`);
        setBusyMessage(nextMessage);
        messageIndex++;
      } else {
        // We've shown all messages, clear the interval
        stopProgress(); // stopProgress clears the interval
        console.log("[DEBUG] All simulated steps shown. Holding on 'Finalizing' and waiting for API response.");
      }
    };

    updateMessage(); // Show the first message immediately
    setIsBusy(true);

    const interval = setInterval(updateMessage, 3000); // Change message every 3 seconds
    setProgressInterval(interval);

    const params = new URLSearchParams();
    params.append("token", token);
    params.append("setup_id", info.setup_id);
    console.log("[DEBUG] Calling apiSetupSchedule with params:", params.toString());
    apiSetupSchedule(params)
      .then((res) => {
        console.log("[DEBUG] apiSetupSchedule successful.", res);
        // Ensure interval is stopped if API finishes before messages do
        if (progressInterval) {
          clearInterval(progressInterval);
          setProgressInterval(null);
        }
        setBusyMessage("Staged Schedule Finalized");
        message.success("Staged Schedule created successfully!");
        // After a short delay to show the final message, go back to the division table.
        setTimeout(() => {
          setBusyMessage("");
          setIsBusy(false);
          onCreate(); // Go back to division table
        }, 2000);
      })
      .catch((err) => {
        console.error("[DEBUG] apiSetupSchedule failed.", err);
        // Network errors sometimes occur even when the schedule is created successfully
        // Show a warning instead of error and allow user to refresh to see results
        console.warn("[DEBUG] Network error occurred but schedule may have been created. Treating as success.");

        // Stop progress and show success message anyway
        if (progressInterval) {
          clearInterval(progressInterval);
          setProgressInterval(null);
        }
        setBusyMessage("Schedule creation completed");
        message.warning("Schedule created, but there was a network issue. Please refresh to verify.");

        setTimeout(() => {
          setBusyMessage("");
          setIsBusy(false);
          onCreate(); // Go back to division table
        }, 2000);
      });
  };

  return (
    <Modal
      open={show}
      destroyOnClose={true}
      onCancel={() => {
        proceed(null);
      }}
      className="schedule-dlg"
      closable={true}
      maskClosable={false}
      title={titleLabel}
      okText="Ok"
      footer={null}
    >
      <Spin spinning={isBusy} tip={busyMessage}>
        {selDivision ? (
          <ScheduleDlgContent
            oneSchedule={oneSchedule}
            setOneSchedule={setOneSchedule}
            errorField={errorField}
            setErrorField={setErrorField}
            token={token}
            club_id={club_id}
            registration_id={registration_id}
            selDivision={selDivision}
            onOk={onCreate}
            isBusy={isBusy}
          />
        ) : (
          <DivisionTable
            dataList={divisionList}
            setSelDivision={setSelDivision}
            setTitleLabel={setTitleLabel}
            editSetup={editSetup}
          />
        )}
      </Spin>
    </Modal>
  );
}

export default confirmable(ScheduleModal);
